<template>
  <div>
    <SectionHeader :title="$t('orders.headline')">
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('meta.orders'), name: 'orders' },
            { text: $t('meta.orderTemplates'), name: 'order_templates' },
            { text: $t('orderTemplates.new'), name: 'new_order_template' },
          ]"
        />
      </template>
    </SectionHeader>

    <div id="order-template-form">
      <div class="content-wrap">
        <header class="content-header cf">
          <h3>{{ $t('orderTemplates.new') }}</h3>
        </header>

        <div class="content-body">
          <OrderTemplateForm @submit="createOrderTemplate" :companyUuid="companyUser.company_uuid" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderTemplateForm from '@/views/order_templates/form'

import BreadCrumbs from '@/components/BreadCrumbs'
import SectionHeader from '@/components/SectionHeader/index.vue'

import orderTemplatesApi from '@/api/orderTemplates'

export default {
  name: 'new_order_template',
  components: { BreadCrumbs, SectionHeader, OrderTemplateForm },
  inject: ['companyUser'],
  data: () => ({
    orderTemplate: {},
  }),
  methods: {
    createOrderTemplate: async function (orderTemplate) {
      const createdOrderTemplate = await orderTemplatesApi.create({
        company_uuid: this.companyUser.company_uuid,
        name: orderTemplate.name,
        order_type: orderTemplate.order_type,
        site_uuid: orderTemplate.site_uuid,
        weekdays: orderTemplate.weekdays,
        vehicle_uuid: orderTemplate.vehicle_uuid,
        paused: orderTemplate.paused,
        continue_on: orderTemplate.paused ? orderTemplate.continue_on : null,
      })

      if (createdOrderTemplate) {
        await this.$router.push('/order_templates')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#order-template-form {
  padding: 1.25rem;
}
</style>
